module.exports = __webpack_public_path__ + "img/underwear_boxers.8dd4e087.png";